import { putBootstrapMirrors } from '@/features/location-bootstrap/location-bootstrap-mirror-writes';
import type { LocationBootstrapPayload } from '@/features/location-bootstrap/location-bootstrap-types';
import type { FieldDatabase, LocationBootstrapRecord } from '@/shared/db/schema';

export class LocationBootstrapRepository {
  constructor(private readonly database: FieldDatabase) {}

  get(input: { apiKey: string; locationId: number | string }) {
    return this.database.get('location_bootstraps', createLocationBootstrapCacheId(input));
  }

  async save(input: { apiKey: string; payload: LocationBootstrapPayload }) {
    const id = createLocationBootstrapCacheId({
      apiKey: input.apiKey,
      locationId: input.payload.locationId,
    });
    const record: LocationBootstrapRecord = {
      apiKeyFingerprint: fingerprintLocationApiKey(input.apiKey),
      data: {
        buildings: input.payload.buildings,
        existingMeters: input.payload.existingMeters,
        location: input.payload.location,
        manufacturers: input.payload.manufacturers,
        meterModels: input.payload.meterModels,
        ownerSuggestions: input.payload.ownerSuggestions,
        tenants: input.payload.tenants,
        thirdParties: input.payload.thirdParties,
      },
      id,
      loadedAt: input.payload.loadedAt,
      locationId: input.payload.locationId,
    };

    await this.database.put('location_bootstraps', record);
    await putBootstrapMirrors(this.database, input.payload);

    return record;
  }

  async listTenants(input: { apiKey: string; locationId: number | string }) {
    const bootstrap = await this.get(input);

    return bootstrap?.data.tenants ?? [];
  }
}

function createLocationBootstrapCacheId(input: { apiKey: string; locationId: number | string }) {
  return `location-bootstrap:${input.locationId}:${fingerprintLocationApiKey(input.apiKey)}`;
}

function fingerprintLocationApiKey(apiKey: string) {
  const normalized = apiKey.trim().toLowerCase();
  let hash = 0;

  for (let index = 0; index < normalized.length; index += 1) {
    hash = (hash * 31 + normalized.charCodeAt(index)) >>> 0;
  }

  return hash.toString(36);
}
